import { NgClass, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Type } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { KatexOptions, MarkdownModule } from 'ngx-markdown';
import { SIMPLE_CALLOUT_VARIANT_CONFIG } from '../../../editor/extensions/simple-callout';
import { SimpleCalloutBlock, SimpleCalloutVariant } from '../../../model';

@Component({
  selector: 'dojo-simple-callout-block-renderer',
  template: `
    <div
      class="simple-callout flex items-start overflow-clip rounded-2xl border"
      [ngClass]="[block().custom_css ?? '', variantConfig().color.border, variantConfig().color.bg]"
    >
      <div class="flex flex-1 flex-col gap-2 p-4 md:gap-3 md:p-4">
        <div class="flex items-center gap-2">
          <div class="shrink-0">
            <dojo-icon [icon]="variantConfig().icon" [ngClass]="variantConfig().color.text" [size]="14" />
          </div>
          <span class="simple-callout-title text-xs font-bold uppercase leading-4" [ngClass]="variantConfig().color.text">
            <markdown [data]="block().title" [inline]="true" katex [katexOptions]="katexOptions" />
          </span>
        </div>

        <div class="simple-callout-content">
          <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: block().content }" />
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../../../editor/extensions/simple-callout/simple-callout-shared.scss'],
  styles: `
    :host ::ng-deep .simple-callout-title markdown {
      display: inline;
    }

    :host ::ng-deep .simple-callout-title markdown p {
      margin: 0;
      display: inline;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgComponentOutlet, NgClass, MarkdownModule],
})
export class SimpleCalloutBlockRendererComponent {
  readonly block = input.required<SimpleCalloutBlock>();
  readonly contentRenderer = input.required<Type<unknown>>();
  readonly katexOptions: KatexOptions = { throwOnError: false, strict: 'warn' };

  readonly variantConfig = computed(() => {
    const variant = this.block().variant ?? SimpleCalloutVariant.Concept;
    return SIMPLE_CALLOUT_VARIANT_CONFIG[variant];
  });
}
